import camelCase from 'lodash/camelCase'
import Vue from 'vue'

class RegisterGlobalFiltersListener {
	async execute() {
		return new Promise((resolve) => {
			const requireFilters = require.context('../../views/filters', true, /[a-z]\w+-filter.(js)$/)
			requireFilters.keys().forEach((fileName) => {
				const filterConfig = requireFilters(fileName)
				const fileNameWithoutDotsAndSubfolders = fileName
					.replace(/^\.\/(.*)\.\w+$/, '$1')
					.replace(/(^[a-z]+)(\/)/, '')
				const filterName = camelCase(fileNameWithoutDotsAndSubfolders)
				Vue.filter(filterName, filterConfig.default || filterConfig)
			})
			resolve()
		})
	}
}

export default new RegisterGlobalFiltersListener()
